import React from "react";
import { withRouter } from "react-router-dom";
import { Image } from "../../../commonComponents";

const QuizBanner = ({ history, location: { search }, image }) => {
  const redirectTo = path => {
    history.push({
      pathname: path,
      search: search
    });
  };

  return (
    <figure
      className="content--component__home-banner"
      onClick={() => redirectTo("quiz")}
    >
      <Image
        className="img-responsive"
        src={image}
        alt=""
      />
    </figure>
  );
};

export default withRouter(QuizBanner);
